import React from "react";

export default function LegalTableOfContents({ sections }) {
  return (
    <nav className="mb-8 p-4 rounded-xl border border-border-light bg-surface-sunken">
      <h2 className="text-sm font-semibold text-text-primary mb-3">
        Contents
      </h2>
      <ol className="list-decimal list-inside space-y-1 text-sm text-primary">
        {sections.map((section) => (
          <li key={section.id}>
            <a href={`#${section.id}`} className="hover:underline">
              {section.title.replace(/^\d+\.\s*/, "")}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
